// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"346":"books","443":"about","915":"bookDetail"}[chunkId] + "." + {"346":"a0fbbf34","443":"f4b9aab6","915":"3cf540f7"}[chunkId] + ".js";
};